import {useMemo} from 'react';

import {CellsConversationsDragItem} from '../../../../../helpers/conversationCellHelpers';
import {
  makeFindConversationActionContext,
  makeFindConversationInboxIds,
  makeFindConversationMessageType,
  makeFindConversationNamespace,
  makeFindConversationSubject,
} from '../../../../../helpers/models/conversationHelpers';
import {ConversationBaseModel} from '../../../../../models/api/conversationModel';
import {CellsContext} from '../../../../../store/panels/cells/context/cellsContext';
import {CellsConversationsDragType} from '../../__mocks__/conversationCellDragSource';

/*
 * Api.
 */

export function useSelectedConversationCellDragItem(
  cellsContext: CellsContext,
  knownSelectedConversations: ReadonlyArray<ConversationBaseModel>,
  sourceCustomViewId: number | undefined,
) {
  return useMemo<CellsConversationsDragItem>(() => {
    const selectedIds = knownSelectedConversations.map((conversation) => conversation.id);

    return {
      type: CellsConversationsDragType,
      conversationIds: selectedIds,
      sourceCustomViewId,
      cellsContext,
      findConversationActionContext: makeFindConversationActionContext(
        cellsContext,
        knownSelectedConversations,
      ),
      findConversationNamespace: makeFindConversationNamespace(knownSelectedConversations),
      findConversationInboxIds: makeFindConversationInboxIds(knownSelectedConversations),
      findConversationSubject: makeFindConversationSubject(knownSelectedConversations),
      findConversationMessageType: makeFindConversationMessageType(knownSelectedConversations),
    };
  }, [cellsContext, knownSelectedConversations, sourceCustomViewId]);
}
